import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import {
    Alert,
    Button,
    Box,
    CircularProgress,
    Container,
    Grid,
    TextField,
} from '@mui/material';

import { fetchRoster } from '../utils/ApiHelper'
import LoadingShells from '../utilComponents/LoadingShells';
import { useAuth } from '../auth/AuthContext';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL


const Auth = () => {

    const [error, setError] = useState();
    const [loginClick, setLoginClick] = useState(false)

    const navigate = useNavigate();
    const { login } = useAuth();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoginClick(true);
        setError()
        const data = new FormData(event.currentTarget);
        console.log("Data:", data.get('username'))
        const body = {
            username: data.get('username'),
            password: data.get('password')
        }

        try {
            const auth = await login(body.username, body.password);
            if (auth.accessToken) {
                try {
                    const roster = await fetchRoster();
                    localStorage.setItem("apiRosterV2", JSON.stringify(roster));
                    navigate("/");
                } catch (rosterError) {
                    console.log("Roster fetch error", rosterError);
                    setError("Failed to fetch roster.");
                    setLoginClick(false);
                }
            } else {
                    setError("No access token received.");
                setLoginClick(false);
            }
        } catch (tokenError) {
            console.log("Login error", tokenError);
            setError(tokenError.message || "Failed to sign in.");
            setLoginClick(false);
        }
    };


    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {loginClick && (
                <LoadingShells />
            )}
            <Container
                component="main"
                maxWidth="xs"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    top: '15vh', // Position 25% down from the top
                    left: '50%', // Center horizontally
                    transform: 'translateX(-50%)', // Center horizontally
                }}>
                <Box
                    sx={{
                        backgroundColor: 'white',
                        padding: 5,
                        borderRadius: 4,
                        border: 1,
                        boxShadow: 10
                    }}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <img
                            loading="lazy"
                            src={`${IMAGE_URL}headers/ASXMarioKart.png`}
                            style={{ width: "75%" }}
                            alt="ASX Mario Kart Title"
                        />
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                            marginTop: 0,
                            borderRadius: 2,
                            boxShadow: 0
                        }}
                    >

                        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label="Username"
                                name="username"
                                autoComplete="username"
                                autoFocus
                                disabled={loginClick}
                                sx={{ backgroundColor: 'white' }}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                disabled={loginClick}
                                sx={{ backgroundColor: 'white' }}
                            />
                            {!loginClick &&
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2, maxWidth: "200px", backgroundColor: 'primary.main', border: 2, boxShadow: 6, borderColor: 'black' }}
                                    >
                                        <img loading="lazy" src={`${IMAGE_URL}navigation/SignIn.png`} style={{ width: "60%" }} alt="Sign In Button" />
                                    </Button>

                                </Box>
                            }
                            {error ? <Alert severity="error" sx={{ marginBottom: 2 }}>{error}</Alert> : null}
                            {loginClick &&
                                <Box sx={{ padding: 3, display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                    <CircularProgress color="secondary" />
                                </Box>}
                        </Box>
                    </Box>
                </Box>
                <Grid container justifyContent="center">
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, maxWidth: "150px", backgroundColor: 'primary.main', border: 2, boxShadow: 6, borderColor: 'black' }}
                    >
                        <img
                            loading="lazy"
                            src={`${IMAGE_URL}navigation/Stats.png`}
                            style={{ width: "90px" }}
                            alt="Stats"
                            onClick={event => navigate('/stats')}
                        />
                    </Button>
                </Grid>

            </Container>
        </Box>
    );
}

export default Auth;
